import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/comics';

const topics = [
  { title: '高分必看榜', desc: '评分 9.5 以上的口碑之作', to: '/top', tone: 'bg-primary-500' },
  { title: '燃向国漫精选', desc: '热血武侠，看得过瘾', to: '/guoman', tone: 'bg-accent-500' },
  { title: '治愈系日漫合集', desc: '温柔日常，治愈人心', to: '/riman', tone: 'bg-secondary-500' },
  { title: '新作抢先看', desc: '2024 上架的潜力新番', to: '/top', tone: 'bg-foreground-800' },
];

export default function TopicSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
          编辑<span className="text-primary-500">专题</span>
        </h2>
        <p className="mt-2 text-sm text-foreground-500">精选合集，快速找到合口味的方向</p>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((t, i) => (
          <Link
            key={t.title}
            to={t.to}
            className={`group relative flex h-48 flex-col justify-between overflow-hidden rounded-2xl p-5 text-background-50 ${t.tone} transition-all duration-300 hover:-translate-y-1 hover:shadow-lift`}
          >
            <div className="absolute right-3 top-3 flex -space-x-3 opacity-90" aria-hidden="true">
              {[i, (i + 1) % 4, (i + 2) % 4].map((idx) => (
                <img
                  key={idx}
                  src={popularComics[idx].cover}
                  alt=""
                  className="h-16 w-11 rounded-md border-2 border-background-50/70 object-cover object-top"
                />
              ))}
            </div>
            <div className="relative">
              <span className="text-xs font-medium text-background-50/80">专题合集</span>
              <h3 className="mt-1 font-heading text-xl">{t.title}</h3>
              <p className="mt-1 text-sm text-background-50/85">{t.desc}</p>
            </div>
            <span className="relative inline-flex items-center gap-1 text-sm font-medium">
              立即查看 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}